import makeSlice from '@web/slices/personalCustomsClearance/sliceMaker'

const slice = makeSlice()

export default slice.reducer
